module.exports = __webpack_public_path__ + "static/media/programmer.2618da14.svg";